// extracted by mini-css-extract-plugin
module.exports = {"popup":"AssignInput_popup__3NOcG","title":"AssignInput_title__3ovKC","item":"AssignInput_item__2WWbu"};